import React from "react";
import { Stack, Progress } from "@mantine/core";
import WebsiteCustomizeOption from "./WebsiteCustomizeOption";
import TemplateOptions from "./TemplateOptions";

interface TemplateSelectorWizardProps {
  templateSelected: string;
  onTemplateSelect: (templateId: string) => void;
}

const TemplateSelectorWizard: React.FC<TemplateSelectorWizardProps> = ({
  templateSelected,
  onTemplateSelect,
}) => {
  return (
    <Stack gap="xl">
      <WebsiteCustomizeOption />
      <TemplateOptions
        templateSelected={templateSelected}
        onTemplateSelect={onTemplateSelect}
      />
    </Stack>
  );
};

export default TemplateSelectorWizard;
